import type { CreateUpdateAssetModel } from './model/assetModel'
import type { SearchAssetResponse } from './model/searchAssetModel'
import type DuneAsset from '@/models/duneAsset'
import Net from '@/services/net'
import utils from '@/services/utils'

export function createAsset(requestObject: CreateUpdateAssetModel) {
  const formData = new FormData()
  for (const key in requestObject) {
    formData.append(key, requestObject[key])
  }
  return Net.dunes.post<{ Id: string, Width: number, Height: number }>(`/assets`, formData)
}

export function updateAsset(assetId: string, requestObject: Record<string, any>) {
  const formData = new FormData()
  for (const key in requestObject) {
    formData.append(key, requestObject[key])
  }
  return Net.dunes.put<{ Id: string }>(`/assets/${assetId}`, requestObject)
}

export function getSilhouetteAssets(context: string, contextKey: string) {
  return Net.dunes.get<DuneAsset[]>(`/assets`, { params: { Context: context, ContextKey: contextKey, ImageSet: 'Silhouette', Status: true } })
}
export function getAssetById(contextKey: string, assetId: string) {
  return Net.dunes.get<DuneAsset>(`/assets/${assetId}`, { params: { ContextKey: contextKey } })
}

export function changeAssetStatus(context: string, contextKey: string, assetIds: string[], status: boolean) {
  const payload = { Context: context, ContextKey: contextKey, Status: status, AssetIds: assetIds }
  return Net.dunes.put(`/assets/status`, payload)
}

export function getDesignOptionAssets(context: string, contextKey: string, modelNumber: string, firstImage: boolean = false, signal?: AbortSignal): Promise<DuneAsset[]> {
  return Net.dunes.get<DuneAsset[]>(`/assets`, { params: { Context: context, ContextKey: contextKey, ImageSet: `${modelNumber}|DO`, Status: true, FirstImage: firstImage }, signal })
    .then((response) => {
      let assets: Array<DuneAsset> = []
      if (response && response.data) {
        assets = utils.sort(response.data, ['SortOrder'])
      }
      return assets
    })
    .catch(() => {
      return []
    })
}

export function convertDesignOptionAsset(requestObject: Record<string, any>) {
  return Net.dunes.put<DuneAsset>(`/assets/designoption`, requestObject)
}

export function searchAssets(context: string, contextKey: string, search: string, top?: number, skip?: number) {
  return Net.dunes.post<SearchAssetResponse>(`/search`, {
    Context: context,
    ContextKey: contextKey,
    text: search,
    top,
    skip,
    includeTotalCount: true,
  })
}

export function filterAssets(context: string, contextKey: string, search: string, filter: string, top?: number, skip?: number) {
  return Net.dunes.post<SearchAssetResponse>(`/search`, {
    Context: context,
    ContextKey: contextKey,
    text: search,
    filter,
    top,
    skip,
    includeTotalCount: true,
  })
}

export function nlpSearchAssets(context: string, contextKey: string, search: string, top?: number, skip?: number) {
  return Net.dunes.post<SearchAssetResponse>(`/search/nlp`, {
    Context: context,
    ContextKey: contextKey,
    text: search,
    top,
    skip,
    includeTotalCount: true,
  })
}

export function reversLookupAssets(context: string, contextKey: string, image: string | null, top?: number, skip?: number) {
  console.log('Reverse lookup image:', image)
  return Net.dunes.post<SearchAssetResponse>(`/search/reverse`, {
    Context: context,
    ContextKey: contextKey,
    image,
    top,
    skip,
    includeTotalCount: true,
  })
}
